module.exports = __webpack_public_path__ + "static/media/land-use.c8d5ac23.svg";